export default __webpack_public_path__ + "static/media/94591245_116479826704122_1897613033518137344_n.c7333504.jpg";